// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"657":"2828b270a6bdb3c8","780":"3430b047c8d73b5e"}[chunkId] + ".js";
};